import * as React from 'react';
import {isTouchDevice} from '../../../utils';
import {LegendWithTooltipProps} from './LegendWithTooltip';

const POPUP_SHOW_DELAY = 700;

const useLegendHandlers = ({
    value,
    legendProps,
    onFocus,
    onBlur,
    onToggleVisibility
}: Partial<LegendWithTooltipProps>): any => {
    const {isHidden, disabled} = legendProps;

    const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);
    const timeoutRef = React.useRef(null);

    const handleClose = () => {
        onBlur(value);
        setIsTooltipOpen(false);
    };

    const handleToggleVisibility = () => {
        if (!disabled) {
            onToggleVisibility(value, isHidden);
            handleClose();
        }
    };

    const legendHandlers = isTouchDevice()
        ? {
              onClick: event => {
                  event.stopPropagation();
                  event.preventDefault();

                  if (isTooltipOpen) {
                      handleClose();
                  } else {
                      setIsTooltipOpen(true);
                      onFocus(value);
                  }
              }
          }
        : {
              onMouseEnter: () => {
                  onFocus(value);
                  timeoutRef.current = setTimeout(() => setIsTooltipOpen(true), POPUP_SHOW_DELAY);
              },
              onMouseLeave: () => {
                  clearTimeout(timeoutRef.current);
                  handleClose();
              },
              onClick: handleToggleVisibility
          };

    return {
        isTooltipOpen,
        legendHandlers,
        handleClose,
        handleToggleVisibility
    };
};

export default useLegendHandlers;
